import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID } from 'utils/types';
import css from './ReasonsDropdownItem.css';
import Icon from '../../../SF/MaterialIcon';
import RadioGroup from '../RadioGroup';

export default class ReasonsDropdownItem extends React.Component {

  constructor() {
    super();
    this.state = { isExpanded: false };
  }

  componentDidMount() {
    this.setState({isExpanded: this.hasItemSelected});
  }

  get caret() {
    return this.state.isExpanded ? "keyboard_arrow_up" : "keyboard_arrow_down";
  }

  get recurringIcon() {
    return this.props.recurring ? <Icon icon="autorenew" /> : null;
  }

  get options() {
    if ( !this.state.isExpanded ) return null;
    return (
      <div className={css['options-container']}>
        <RadioGroup
          name={this.props.radioName}
          options={this.props.appointmentReasons}
          value={this.props.value}
          onSelectOption={this.props.onReasonSelected}
        />
      </div>
    );
  }

  get hasItemSelected() {
    let hasSelected = false;
    this.props.appointmentReasons.forEach(({id}) => {
      if ( parseInt(this.props.value) === parseInt(id) ) hasSelected = true;
    });
    return hasSelected;
  }

  render() {
    return (
      <div>
        <div
          className={css['container']}
          aria-expanded={this.state.isExpanded}
          onClick={() => this.setState({isExpanded: !this.state.isExpanded})}
          role="button"
          tabIndex={0}>
          <div>{this.props.name} {this.recurringIcon}</div>
          <div><Icon icon={this.caret} /></div>
        </div>
        {this.options}
      </div>
    );
  }
}

ReasonsDropdownItem.propTypes = {
  radioName: PropTypes.string.isRequired,
  recurring: PropTypes.bool,
  appointmentReasons: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  value: SFEntityID,
  onReasonSelected: PropTypes.func.isRequired
};
